// Render and validate profile fields
import React from "react";
import { useFormContext } from "react-hook-form";
import FullName from "./FullNameField";
import Reason from "./Reason";

const CreateProfile = () => {
  const { register, formState } = useFormContext();
  return (
    <div className="component-create-profile">
      <h3>Member profile</h3>
      <FullName />
      <div className="field">
        <input
          id="username"
          type="text"
          placeholder=" "
          {...register("username", {
            required: true,
            pattern: /^[A-Za-z0-9_@.+-]*$/i,
          })}
          className={
            (formState.errors.username && "error") ||
            (formState.dirtyFields.username && "valid")
          }
        />
        <label htmlFor="username">Username</label>
        <span className="field-error-msg">
          {formState?.errors?.username?.type === "required" &&
            "Please choose a username"}
          {formState?.errors?.username?.type === "pattern" &&
            "Your username contains a disallowed special character"}
          {formState?.errors?.username?.type === "api" &&
            formState?.errors?.username?.message}
        </span>
      </div>
      <div className="field">
        <input
          id="password"
          type="password"
          placeholder=" "
          {...register("password", {
            required: true,
            minLength: { value: 8 },
          })}
          className={
            (formState.errors.password && "error") ||
            (formState.dirtyFields.password && "valid")
          }
        />
        <label htmlFor="password">Password</label>
        <span className="field-error-msg">
          {formState?.errors?.password?.type === "required" &&
            "Please choose a password"}
          {formState?.errors?.password?.type === "minLength" &&
            "Your password must be at least 8 characters"}
          {formState?.errors?.password?.type === "api" &&
            formState?.errors?.password?.message}
        </span>
      </div>
      <Reason placeholder="Why are you joining Long Now today? Optional, but we're listening..." />
    </div>
  );
};
export default CreateProfile;
